import type {
  ModuleTabKey,
  RequirementRowKey,
} from "@/features/certifications/module/types";

export const MODULE_TABS = {
  THIS_WEEK: "thisWeek",
  RESOURCES: "resources",
} as const satisfies Record<string, ModuleTabKey>;

export const REQUIREMENT_ROW_KEYS = {
  VIDEOS: "videos",
  READINGS: "readings",
  KNOWLEDGE_CHECK: "knowledgeCheck",
  COMMUNITY: "community",
} as const satisfies Record<string, RequirementRowKey>;
